import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlanQuizComponent } from 'src/app/study-planner/components/plan-quiz/plan-quiz.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';




import {RadioButtonModule} from 'primeng/radiobutton';
import {TooltipModule} from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import {DropdownModule} from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';
import {InputNumberModule} from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';




@NgModule({
  declarations: [PlanQuizComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    CheckboxModule,
    InputNumberModule,
    RadioButtonModule,
    DropdownModule,DialogModule,
    ToastModule,
  ]
  ,
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    TooltipModule,
    CheckboxModule,
    InputNumberModule,
    RadioButtonModule,
    DropdownModule,
    ToastModule,
    PlanQuizComponent,
 
  ]
  ,

})
export class SharedModule { }
